import { defineAgenda } from '@/shared/navigation/core';
import { listPageViewState } from '@/shared/navigation/react/listPageViewState';

/**
 * Agenda seznamu stanic (číselník) — kořenová agenda slicu Products. Univerzální ListPage
 * (engine `@/shared/ui/list-page`, šablona `stationListPage.tsx`). Otevírá detail jako modální vrstvu.
 */
export const stationListAgenda = defineAgenda({
  id: 'app.products.stations',
  path: 'app/products/stations',
  open: {},
  state: listPageViewState,
  title: 'Stanice',
  icon: 'map-pin',
});
